import { SupportedCountryCodes } from '../models/types'

const US_ZIPCODE_PATTERNS = new RegExp(/^[0-9]{5}(-[0-9]{4})?$/)
const CA_ZIPCODE_PATTERNS = new RegExp(
  /([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i
)
const AU_ZIPCODE_PATTERNS = new RegExp(/^[0-9]{4}$/)
const JP_ZIPCODE_PATTERNS = new RegExp(/^〒?[0-9]{3}-[0-9]{4}$/)
const DE_ZIPCODE_PATTERNS = new RegExp(/^[0-9]{5}$/)

const supportedCountryCodesToZipPatterns: Record<
  SupportedCountryCodes,
  RegExp
> = {
  US: US_ZIPCODE_PATTERNS,
  CA: CA_ZIPCODE_PATTERNS,
  AU: AU_ZIPCODE_PATTERNS,
  JP: JP_ZIPCODE_PATTERNS,
  DE: DE_ZIPCODE_PATTERNS,
}

export const getZipWithCountry = (zipCode: string, countryCode?: string) => {
  let zipWithCountry = `${zipCode} United States`
  if (AU_ZIPCODE_PATTERNS.test(zipCode)) {
    zipWithCountry = `${zipCode} Australia`
  } else if (CA_ZIPCODE_PATTERNS.test(zipCode)) {
    zipWithCountry = `${zipCode} Canada`
  } else if (JP_ZIPCODE_PATTERNS.test(zipCode)) {
    zipWithCountry = `${zipCode} Japan`
  } else if (DE_ZIPCODE_PATTERNS.test(zipCode) && countryCode == 'DE') {
    zipWithCountry = `${zipCode} Germany`
  }
  return zipWithCountry
}

export const getPossibleCountryCodesFromZip = (
  zipCode: string
): SupportedCountryCodes[] =>
  Object.entries(supportedCountryCodesToZipPatterns).reduce(
    (prev, [countryCode, zipPattern]: [SupportedCountryCodes, RegExp]) => {
      if (zipPattern.test(zipCode)) {
        prev.push(countryCode)
      }
      return prev
    },
    [] as SupportedCountryCodes[]
  )
